import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { DeleteOutlined, VisibilityOutlined } from "@mui-symbols-material/w300"
import { useNavigate } from "@tanstack/react-router"

interface ContactRowDropdownMenuProps {
  anchorEl: HTMLElement | null
  onClose: () => void
  onRemoveFromLocation: () => void
  contactId: string
}

const ExpandedLocationRowDropdownMenu: React.FC<ContactRowDropdownMenuProps> = ({
  anchorEl,
  onClose,
  onRemoveFromLocation,
  contactId,
}) => {
  const navigate = useNavigate()
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem
        onClick={() => {
          navigate({ to: `/app/contact/${contactId}` })
          onClose()
        }}
      >
        <ListItemIcon>
          <VisibilityOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Contact Details' />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onRemoveFromLocation()
          onClose()
        }}
      >
        <ListItemIcon>
          <DeleteOutlined sx={{ fontVariationSettings: '"wght" 300' }} />
        </ListItemIcon>
        <ListItemText primary='Remove from Location' />
      </MenuItem>
    </Menu>
  )
}

export default ExpandedLocationRowDropdownMenu
